import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {InicioFaces} from '../interfaces/inicioFaces';
import {HttpParams} from  "@angular/common/http";
import {environment} from "../../environments/environment";
import Constants from "../lib/Constants";

@Injectable({
  providedIn: 'root'
})
export class CertificadosService {
	public httpOptions = {
		headers: new HttpHeaders({
			'Access-Control-Allow-Origin': '*'
		})

	 };

API_ENDPOINT: string =Constants.BASEURLAPI  + '/api';


  constructor(private httpClient: HttpClient) {


   }

  public listarCertificados(id) {
        const  params = new  HttpParams().set('documento_id', id);
        return this.httpClient.get(this.API_ENDPOINT + '/listarCertificados',{ params });
    }

  public listarDesprendibles(id) {
        const  params = new  HttpParams().set('documento_id', id);
        return this.httpClient.get(this.API_ENDPOINT + '/listarDesprendibles',{ params });
    }


}
